import { render } from "./DsPolicyAuthorizedSkeleton.vue?vue&type=template&id=a32c55a2"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__